var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { equals } from 'ramda';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { mapElementClass, omitSpecialProperties } from '../../common';
import { Slider } from 'primereact/slider';
import { InputText } from 'primereact/inputtext';
import { ControlError } from './ControlError';
import * as R from 'ramda';
var SliderbarControl = /** @class */ (function (_super) {
    __extends(SliderbarControl, _super);
    function SliderbarControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (target) { return function (evt) {
            if (!equals(_this.value, evt.value)) {
                var value = evt.value;
                var max = R.path(['def', 'frontOptions', 'maxCustom'], _this.state);
                var min = R.path(['def', 'frontOptions', 'minCustom'], _this.state);
                if (max || min) {
                    value = value < min ? min : (value > max ? max : value);
                }
                _this.handleChange(value);
                var type = target.actionButton;
                if (type) {
                    _this.props.onEvent({ type: type, target: target });
                }
            }
        }; };
        return _this;
    }
    SliderbarControl.prototype.elementRender = function (def) {
        var _this = this;
        var _a = def.frontOptions, hint = _a.hint, step = _a.step, label = _a.label, placeholder = _a.placeholder, labelValue = _a.labelValue, showLabel = _a.showLabel, restOptions = __rest(_a, ["hint", "step", "label", "placeholder", "labelValue", "showLabel"]);
        var value = parseFloat(this.value);
        var printLabel = label || def.label;
        return def.hidden ? null : React.createElement("div", { className: mapElementClass(restOptions) },
            React.createElement("label", { htmlFor: def.id, title: printLabel }, printLabel),
            React.createElement("div", { className: 'without-padding sum-control' },
                React.createElement(InputText, __assign({}, omitSpecialProperties(restOptions), { ref: function (ref) {
                        if (ref) {
                            ref['element'].setAttribute('field-code', def.code);
                        }
                    }, key: def.id + 1, id: def.id + 1, disabled: def.disabled, readOnly: def.readonly, onChange: function (evt) { return _this.handleChange(evt.target.value); }, onBlur: this.handleBlur, onFocus: this.handleFocus, value: this.value || '', tooltip: hint, placeholder: placeholder || null, style: { padding: '0.5em', position: 'relative' } })),
                React.createElement("label", { htmlFor: def.id, style: { display: !showLabel ? "none" : "block", position: 'absolute', right: '1em', top: '1.5em' } }, labelValue)),
            React.createElement(Slider, __assign({}, omitSpecialProperties(restOptions), { ref: function (ref) {
                    if (ref) {
                        ref['el'].setAttribute('field-code', def.code);
                    }
                }, key: def.id + 2, id: def.id + 2, step: step || 1, disabled: def.disabled || def.readonly, onChange: this.onChange(def), value: isNaN(value) ? undefined : value })),
            React.createElement(ControlError, { error: this.error, touched: this.touched }));
    };
    return SliderbarControl;
}(FormBaseElement));
export { SliderbarControl };
//# sourceMappingURL=Sliderbar.js.map